import React, { useMemo } from 'react';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import EditionsTable from './Table';
import Visualis from './Visualis';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { getCountriesCardTitleI18nKey } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/_config/countriesCardTitle';

const CountriesCard = (props: any) => {
  const {
    lineData,
    tableData = [],
    latestDay = '',
    unPublishedAppIdList = [],
    cardStatus,
    entityType
  } = props;

  const { formatMessage } = useIntlExtend(); // 中英切换方法
  const { isLoading, isError, isNoData } = cardStatus || {};

  const countriesSharTitle = useMemo(() => {
    const titleI18nKey = getCountriesCardTitleI18nKey({
      dimension: 'market',
      metric: 'lifetime_retention',
      chartType: 'line',
    });

    return formatMessage({ id: titleI18nKey });
  }, [formatMessage]);

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={countriesSharTitle}
        subTitle={'All of time'}
        rightText={latestDay ? `${formatMessage({ id: 'dbi_detail_latest_date' })}: ${latestDay}` : ''}
        rightTip={latestDay ? formatMessage({ id: 'dbi_detail_latestdate_info' }) : ''}
        iconList={[]}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  return (
    <CardSlotV2
      className="dbi-mobileGames-card-context"
      title={countriesSharTitle}
      subTitle={'All of time'}
      rightText={latestDay ? `${formatMessage({ id: 'dbi_detail_latest_date' })}: ${latestDay}` : ''}
      rightTip={latestDay ? formatMessage({ id: 'dbi_detail_latestdate_info' }) : ''}
      disableChartType={['bar', 'pie']}
      activeTab={'line'}
    >
      <div className="trends-card-line">
        <Visualis lineData={lineData} />
      </div>
      <EditionsTable
        tableData={tableData}
        unPublishedAppIdList={unPublishedAppIdList}
        entityType={entityType}
      />
    </CardSlotV2>
  );
};

export default CountriesCard;
